import React from 'react';

import { Link } from 'react-router-dom';
import {Card} from '@betareader/design-system';
import { withTranslation, Trans } from 'react-i18next';

import ShareAuthorApp from '../sharing/shareAuthorApp';

// stateless component
const GetMoreReadersMessage = ({ user, userProfile }) => (
  <Card style={{borderLeft: '4px solid var(--br-accent)'}}>
    <Trans i18nKey='referralText'>
      <h3 style={{fontWeight: 'normal'}}>Get up to 10 extra reader slots by inviting your friends to BetaReader.io!</h3>
      <p style={{ fontWeight: 'lighter' }}>For every friend who creates a validated author account and lists a manuscript thanks to you, we will give you and your friend 1 reader slot each, up to a maximum of 10 slots.</p>
      <p style={{ fontWeight: 'lighter' }}>You can also raise your reader limit by reading and reviewing 100k words via our <Link to='/discover'><strong>reader app</strong></Link>, or by <Link to='/products'><strong>upgrading</strong></Link> your account!</p>
    </Trans>
    <hr />
    <ShareAuthorApp user={user} userProfile={userProfile} />
  </Card>
);

export default withTranslation()(GetMoreReadersMessage);
